import { render } from "./SemAcessoMultiplicador.vue?vue&type=template&id=6d921a4e"
import script from "./SemAcessoMultiplicador.vue?vue&type=script&lang=js"
export * from "./SemAcessoMultiplicador.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__